<template>
  <section class="p-t110 z-index-1 section-contact">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-xs-12 q-pa-md">
          <div class="our-contact text-light">
            <div class="ot-heading text-light">
              <h6 class="q-my-md">
                <q-chip color="accent" size="1rem" text-color="secondary" class="q-px-lg"> <span>İletişim Detayları</span></q-chip>
              </h6>
              <h2 class="main-heading">İletişim Bilgilerimiz</h2>
            </div>
            <p class="m-b45">
              Herhangi bir zaman arayabilir veya uğrayabilirsiniz, iş günlerinde tüm sorularınıza en geç 24 saat içinde cevap vermeyi taahhüt ediyoruz. Sorularınızı
              yanıtlamaktan mutluluk duyacağız.
            </p>
            <div class="contact-info text-light m-b30">
              <i class="flaticon-world"></i>
              <div class="info-text">
                <h6 class="text-secondary">Adresimiz:</h6>
                <p>{{ companyInfo.companyAddress }}</p>
              </div>
            </div>
            <div class="contact-info text-light m-b30">
              <i class="flaticon-note"></i>
              <div class="info-text">
                <h6 class="text-secondary">E-Posta Adresimiz:</h6>
                <p>
                  <a :href="`mailto:${companyInfo.companyEmail}`">{{ companyInfo.companyEmail }}</a>
                </p>
              </div>
            </div>
            <div class="contact-info text-light">
              <i class="flaticon-viber"></i>
              <div class="info-text">
                <h6 class="text-secondary">Telefon Numaramız:</h6>
                <p>
                  <a href="tel:${companyInfo.companyPhone}">{{ companyInfo.companyPhone }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12 q-pa-md align-self-center">
          <div class="form-contact q-mb-xl">
            <div class="ot-heading">
              <h6 class="q-my-md">
                <q-chip color="accent" size="1rem" text-color="secondary" class="q-px-lg"><span>İletişime Geçin</span> </q-chip>
              </h6>
              <h2 class="main-heading">Bize Ulaşın</h2>
            </div>
            <form action="contact.php" class="wpcf7-form" method="POST">
              <p>
                <span class="wpcf7-form-control-wrap your-name">
                  <q-input outlined type="text" name="name" id="name" v-model="formData.adSoyad" class="wpcf7-form-control wpcf7-text" placeholder="Adınız Soyadınız *" />
                </span>
              </p>
              <p>
                <span class="wpcf7-form-control-wrap your-email">
                  <q-input
                    outlined
                    type="email"
                    name="email"
                    id="email"
                    v-model="formData.eposta"
                    class="wpcf7-form-control wpcf7-text wpcf7-email"
                    placeholder="E-posta Adresiniz *"
                  />
                </span>
              </p>
              <p>
                <span class="wpcf7-form-control-wrap your-message">
                  <q-input
                    type="textarea"
                    outlined
                    name="message"
                    id="message"
                    v-model="formData.aciklama"
                    class="wpcf7-form-control wpcf7-textarea"
                    placeholder="Mesajınız..."
                  ></q-input>
                </span>
              </p>
              <div class="flex items-center no-wrap">
                <q-toggle v-model="formData.gdprAgreement" color="green" class="q-mt-none"> </q-toggle>
                <div>
                  <k-v-k-k-agreements toggle-accept @accept="formData.gdprAgreement = true">
                    <template #activator="{ toggleDialog }">
                      <basic-link href="#" @click="toggleDialog">KVKK Aydınlatma Metni</basic-link>
                    </template>
                  </k-v-k-k-agreements>
                  'ni okudum ve kabul ediyorum
                </div>
              </div>
              <div class="flex items-center no-wrap q-mb-md">
                <q-toggle v-model="formData.kvkkInformationAgreement" color="green" class="q-mt-none"> </q-toggle>
                <div>
                  Kişisel verilerimin yurt dışında bulunan sunucularda işlenmesine ve saklanmasına açık rıza veriyorum.
                  <k-v-k-k-information toggle-accept @accept="formData.kvkkInformationAgreement = true">
                    <template #activator="{ toggleDialog }">
                      <basic-link href="#" @click="toggleDialog">Detaylı Bilgi</basic-link>
                    </template>
                  </k-v-k-k-information>
                </div>
              </div>
              <div>
                <q-btn color="blue" no-caps @click="sendMessage" :loading="contactFormLoading" type="button" class="octf-btn octf-btn-primary octf-btn-icon q-px-lg">
                  Mesajınızı Gönderin
                  <q-icon name="fa-solid fa-paper-plane" size="1rem" right />
                </q-btn>
              </div>
            </form>
          </div>
          <!--          <q-expansion-item-->
          <!--            label="Yasal Bilgiler"-->
          <!--            icon="info"-->
          <!--            header-class="bg-blue text-white"-->
          <!--            style="border-radius: 30px; overflow: hidden"-->
          <!--            expand-icon-class="text-white"-->
          <!--            class="q-px-lg"-->
          <!--          >-->
          <!--            <q-card>-->
          <!--              <q-card-section>-->
          <!--                <div class="row q-mb-xl">-->
          <!--                  <div class="col-12 col-md-6 q-px-sm q-mb-sm">-->
          <!--                    <strong>Vergi Numarası: </strong>-->
          <!--                    <br />-->
          <!--                    <span class="q-ml-xs">{{ legalInfo.taxNumber || '-' }}</span>-->
          <!--                  </div>-->
          <!--                  <div class="col-12 col-md-6 q-px-sm q-mb-sm">-->
          <!--                    <strong>Vergi Dairesi: </strong>-->
          <!--                    <br />-->
          <!--                    <span class="q-ml-xs">{{ legalInfo.taxOffice || '-' }}</span>-->
          <!--                  </div>-->
          <!--                  <div class="col-12 col-md-6 q-px-sm q-mb-sm">-->
          <!--                    <strong>Tescil Tarihi: </strong>-->
          <!--                    <br />-->
          <!--                    <span class="q-ml-xs">{{ legalInfo.registrationDate ? dateFormat(legalInfo.registrationDate) : '-' }}</span>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </q-card-section>-->
          <!--            </q-card>-->
          <!--          </q-expansion-item>-->
          <!--          <div class="form-contact q-mb-xl">-->
          <!--            <div class="ot-heading">-->
          <!--              <h3 class="main-heading" style="margin-bottom: 10px">Yasal Bilgiler</h3>-->
          <!--            </div>-->
          <!--            <div class="row q-mb-xl">-->
          <!--              <div class="col-12 col-md-6 q-px-sm q-mb-sm">-->
          <!--                <strong>Vergi Numarası: </strong>-->
          <!--                <br />-->
          <!--                <span class="q-ml-xs">{{ legalInfo.taxNumber || '-' }}</span>-->
          <!--              </div>-->
          <!--              <div class="col-12 col-md-6 q-px-sm q-mb-sm">-->
          <!--                <strong>Vergi Dairesi: </strong>-->
          <!--                <br />-->
          <!--                <span class="q-ml-xs">{{ legalInfo.taxOffice || '-' }}</span>-->
          <!--              </div>-->
          <!--              <div class="col-12 col-md-6 q-px-sm q-mb-sm">-->
          <!--                <strong>Tescil Tarihi: </strong>-->
          <!--                <br />-->
          <!--                <span class="q-ml-xs">{{ legalInfo.registrationDate ? dateFormat(legalInfo.registrationDate) : '-' }}</span>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </section>
  <!--  <section id="CompanyLocationMap">-->
  <!--    <div class="map">-->
  <!--      <iframe-->
  <!--        src="https://maps.google.com/maps?hl=en&amp;q=Fenerbah%C3%A7e%20mah.%20%C4%B0%C4%9Frip%20sk.%20Kap%C4%B1%20no%3A%2013%20Daire%20no%3A%201%20-%20KADIK%C3%96Y+(KorhanSoft%20Innovation%20Technologies)&amp;ie=UTF8&amp;t=&amp;z=12&amp;iwloc=B&amp;output=embed"-->
  <!--        width="100%"-->
  <!--        height="500"-->
  <!--        frameborder="0"-->
  <!--        style="border: 0"-->
  <!--        allowfullscreen=""-->
  <!--        aria-hidden="false"-->
  <!--        tabindex="0"-->
  <!--      ></iframe>-->
  <!--    </div>-->
  <!--  </section>-->
</template>

<script lang="ts">
import { defineComponent, Ref, ref } from 'vue';
import ContactService from 'src/core/services/ContactService';
import { useQuasar } from 'quasar';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';
import BasicLink from 'components/BasicLink.vue';
import KVKKInformation from 'components/User/Registration/KVKKInformation.vue';
import KVKKAgreements from 'components/User/Registration/KVKKAgreements.vue';

export default defineComponent({
  name: 'Contact',
  components: { KVKKAgreements, KVKKInformation, BasicLink },

  inject: ['siteLang', 'siteContent'],

  computed: {
    companyInfo() {
      return this.siteHead.company;
    },
    legalInfo() {
      return this.siteContent.legalInfo;
    },
  },

  setup() {
    const $q = useQuasar();

    const pageStore = PageStore();
    const { head, content }: { head: any; content: Ref<CategoryContent> } = storeToRefs(pageStore);

    const formData = ref({
      adSoyad: '',
      eposta: '',
      aciklama: '',
      gdprAgreement: false,
      kvkkInformationAgreement: false,
    });

    const contactFormLoading = ref(false);

    return {
      siteHead: head.value,
      siteContent: content.value,
      formData,
      contactFormLoading,
      sendMessage() {
        const { adSoyad, eposta, aciklama, gdprAgreement, kvkkInformationAgreement } = formData.value;

        if (gdprAgreement === false || kvkkInformationAgreement === false) {
          $q.notify({
            color: 'negative',
            message: 'KVKK ve KVKK bilgi paylaşımını kabul etmeniz gerekmektedir.',
            position: 'bottom',
            icon: 'error',
          });
          return;
        }

        contactFormLoading.value = true;
        ContactService.sendMessageContact({ adSoyad, eposta, aciklama })
          .then(({ status, message }) => {
            if (status._200_) {
              $q.notify({
                type: 'positive',
                message: 'Mesajınız tarafımıza ulaşmıştır, teşekkür ederiz.',
              });

              formData.value.adSoyad = '';
              formData.value.eposta = '';
              formData.value.aciklama = '';
            } else if (String(status)[0] === '4') {
              $q.notify({
                type: 'warning',
                message,
              });
            } else {
              $q.notify({
                type: 'negative',
                message: 'Mesaj gönderiminde bir hata meydana geldi, lütfen yakın zamanda tekrar deneyiniz.',
              });
            }
          })
          .finally(() => {
            contactFormLoading.value = false;
          })
          .catch(() => {
            contactFormLoading.value = false;
          });
      },
    };
  },

  methods: {
    dateFormat(date: string) {
      return new Intl.DateTimeFormat(this.siteLang, {
        dateStyle: 'long',
      }).format(new Date(date));
    },
  },
});
</script>

<style scoped lang="sass">
.main-heading
  font-size: 1.7rem
  font-weight: 600
  margin-bottom: 2.25rem

.info-text
  h6
    font-size: 1.2rem
    font-weight: 600
    margin-bottom: 0.5rem

  p
    font-size: .9rem
    font-weight: 500

  a
    color: $primary
    text-decoration: none

    &:hover
      text-decoration: underline
</style>
